import React, { useEffect, useMemo } from 'react';
import FieldSelect from './fieldSelect';
import { useQueryBuilderState } from '../queryBuilderContext';
import { getResourceFromQuery } from '../utils';

interface ResourceSelectProps {
  onChange: (resource: string) => void;
  disabled?: boolean;
}

const ResourceSelect: React.FC<ResourceSelectProps> = ({ onChange, disabled }) => {
  const { inputQuery, resource, resources } = useQueryBuilderState();
  useEffect(() => {
    const resourceFromQuery = getResourceFromQuery(inputQuery);
    if (resourceFromQuery !== resource && resources.some((r) => r.name === resourceFromQuery)) {
      onChange(resourceFromQuery);
    }
  }, [inputQuery, resources]);
  const resourcesOptions = useMemo(
    () =>
      resources.map((rsrc) => ({
        value: rsrc.name,
        label: rsrc.displayName,
        description: rsrc.description,
      })),
    [resources],
  );

  return (
    <FieldSelect
      disabled={disabled}
      value={resource}
      showSearch
      size="small"
      bordered={false}
      options={resourcesOptions}
      onChange={onChange}
      mode={undefined}
    />
  );
};

export default ResourceSelect;
